import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import "react-dates/initialize";
import React from "react";
import PropTypes from "prop-types";
import momentPropTypes from "react-moment-proptypes";
import { DayPickerSingleDateController } from "react-dates";
import classesPropType from "@xo-union/classes-prop-type";
import Icon from "@xo-union/tk-component-icons";

var DatePicker = function DatePicker(_ref) {
  var classes = _ref.classes,
      props = _objectWithoutProperties(_ref, ["classes"]);

  return React.createElement("div", {
    className: classes.container
  }, React.createElement("div", {
    className: classes['arrow-up']
  }), React.createElement(DayPickerSingleDateController, _extends({
    numberOfMonths: 1,
    transitionDuration: 0,
    navPrev: React.createElement(Icon, {
      name: "caret_left",
      size: "md"
    }),
    navNext: React.createElement(Icon, {
      name: "caret_right",
      size: "md"
    }),
    hideKeyboardShortcutsPanel: true
  }, props)));
};

process.env.NODE_ENV !== "production" ? DatePicker.propTypes = {
  /**
   * Classes
   */
  classes: classesPropType(['container', 'arrow-up']),

  /**
   * Moment date object or null.
   */
  date: momentPropTypes.momentObj,

  /**
   * Callback triggered when user selects a date.
   */
  onDateChange: PropTypes.func
} : void 0;
export default DatePicker;